import ListingVM from './listing-vm';

export default {
  init: function(node) {
    const data = JSON.parse(node.dataset.carouselData);
    ko.applyBindings(new ListingVM(data, node), node);
  }
};